import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = function Page(): JSX.Element {
  throw new Error('test error')
}

export const Route = createFileRoute('/debug/error-sync')({
  component: RouteComponent as React.FC,
})
